import {isNilOrEmpty} from 'ramda-adjunct';

import {isNotNilOrEmpty, Nullish} from 'shared/web';

import {ListFeaturesItemProps} from '../components/ListFeatures/components/ListFeaturesItem';

type PartialFeature = Omit<ListFeaturesItemProps, 'title'> & {title: string | Nullish};

export function isListFeatureVisible(
  feature: PartialFeature,
  showEmptyFields: boolean
): feature is ListFeaturesItemProps {
  if (isNilOrEmpty(feature.title)) {
    return false;
  }
  if (showEmptyFields) {
    return true;
  }

  const isSet =
    isNotNilOrEmpty(feature.flagText) ||
    isNotNilOrEmpty(feature.flagTexts) ||
    isNotNilOrEmpty(feature.description) ||
    isNotNilOrEmpty(feature.tooltipText) ||
    isNotNilOrEmpty(feature.value);

  return isSet;
}
